import { Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { useEffect } from 'react';

import PageNotFound from '../PageNotFound.js'
import PHome from './PHome.js'
import PMissionDetails from './PMissionDetails.js';
import Login from './Login.js';
import PrimaryLogin from './PrimaryLogin.js';
import SecondaryLogin from './SecondaryLogin.js';

import Home from './Home.js';
import MissionDetails from './MissionDetails.js';

function App(props) {

    return (
      <div className="root" style={{}}>
        <div className='flex-1 w-full flex flex-row' style={{ overflow: 'hidden' }}>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Login />} />
            <Route path="/pmissions" element={<PHome />} />
            <Route path="/secondary" element={<SecondaryLogin />} />
            <Route path="/primary" element={<PrimaryLogin />} />
            <Route path="/pmissions/:id" element={<PMissionDetails />} />

            <Route path="/missions" element={<Home />} />
            <Route path="/missions/:id" element={<MissionDetails />} />

            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </div>
    );


}

export default connect((store) => {
  return {
    token: store.tokenReducer,
    control: store.controlReducer,
  }
})(App)